module.exports = __webpack_public_path__ + "static/img/s57.d71687aa.png";